.header {
  position: relative;
  z-index: 1000;
  background: var(--vkui--color_background_content);
}

.closeButton {
  cursor: pointer;
}
